export function scoreToStars(score: number | undefined) {
	const countableScore = typeof score === 'number' ? Math.max(0, score) : 0
	const starAmount = Math.ceil((5 * (countableScore + 1)) / 100)
	if (starAmount > 5) {
		return 5
	}
	return starAmount
}
